module.exports = __webpack_public_path__ + "6af4d6cd942b9151736e3de59d5d8427.pdf";